import {FC} from "react";
import {PlusOutlined} from "@ant-design/icons";
import {UploaderProps} from "./types";
import {Spin, Upload, UploadFile} from "antd";
import {useUploadController} from "../../controllers/upload-controller";


const Uploader: FC<UploaderProps> = (props) => {
  const {files, setFiles, customUploadItemRender, bucketId, maxCount} = props
  const {uploadFile, isFilesLoading, deleteFile} = useUploadController()
  const uploadButton = (
    <button style={{border: 0, background: 'none'}} type="button">
      <PlusOutlined/>
      <div style={{marginTop: 8}}>Завантажити</div>
    </button>
  );

  const removeButtonHandler = async (file: UploadFile) => {
    if (file.status === "done") {
      const fileId = file.response.$id
      const buketId = file.response.bucketId
      if (fileId && buketId) {
        await deleteFile({fileId, buketId})
      }
    }
  }


  return (
    <Spin spinning={isFilesLoading}>
      <Upload
        maxCount={maxCount}
        listType="picture-card"
        fileList={files}
        onRemove={removeButtonHandler}
        onChange={({file, fileList}) => {
          setFiles(fileList)
        }}
        itemRender={customUploadItemRender}
        customRequest={async (props) => {
          const {onSuccess, onError, file, onProgress} = props;
          const correctFile = file as unknown as File
          await uploadFile({...props, bucketId})
        }}

      >
        {uploadButton}
      </Upload>
    </Spin>
  )
}

export default Uploader